import { delay1diib1rb84y4j as delay } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  toList3jhuyej2anx2q as toList,
  zipfdxxupzuj2p9 as zip,
  joinToString1cxrrlmo0chqs as joinToString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { printStackTrace18lnx7a39cni as printStackTrace } from '../../../../../kotlin-kotlin-stdlib/kotlin/throwableExtensions.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { identityHashCodemue8eqr5m304 as identityHashCode } from '../../../../../kiteui-library/com/lightningkite/kiteui/debugger.js.mjs';
import { CompletableDeferred2lnqvsbvx74d3 as CompletableDeferred } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CompletableDeferred.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { arrayListOf1fz8nib0ncbow as arrayListOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { HashSet2dzve9y63nf0v as HashSet } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/HashSet.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  Companion_getInstance3vz87v4c01z2t as Companion_getInstance,
  toDuration28gf6ughsr3vf as toDuration,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_SECONDS_getInstance3jias9ne5z4er as DurationUnit_SECONDS_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { HashMap1a0ld5kgwhmhv as HashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/HashMap.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_invoke__zhh2q8($this, $this$launch, $completion) {
  var tmp = delay($this.oej_1.jej_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp0_safe_receiver = $this.oej_1.kej_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.hcv(['Starting request']);
  }
  if ($this.oej_1.nej_1 === $this.pej_1)
    $this.oej_1.nej_1 = null;
  try {
    var allInputs = toList($this.pej_1);
    var tmp_0 = $this.oej_1.lej_1(allInputs, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    var allOutputs = zip(allInputs, tmp_0);
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = allOutputs.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      var key = element.cf();
      var value = element.df();
      var out = $this.oej_1.mej_1.t3(key);
      var tmp0_safe_receiver_0 = $this.oej_1.kej_1;
      if (tmp0_safe_receiver_0 == null)
        null;
      else {
        var tmp_1;
        if (out == null) {
          tmp_1 = null;
        } else {
          tmp_1 = joinToString(out, VOID, VOID, VOID, VOID, VOID, BatchAndQueue$invoke$slambda$lambda);
        }
        tmp0_safe_receiver_0.hcv(['Finished request.  Sending results to ' + tmp_1]);
      }
      if (out == null)
        null;
      else {
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s_0 = out.m1();
        while (_iterator__ex2g4s_0.n1()) {
          var element_0 = _iterator__ex2g4s_0.o1();
          element_0.pa8(value);
        }
      }
    }
  } catch ($p) {
    if ($p instanceof Exception()) {
      var e = $p;
      printStackTrace(e);
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s_1 = $this.pej_1.m1();
      while (_iterator__ex2g4s_1.n1()) {
        var element_1 = _iterator__ex2g4s_1.o1();
        var out_0 = $this.oej_1.mej_1.t3(element_1);
        var tmp0_safe_receiver_1 = $this.oej_1.kej_1;
        if (tmp0_safe_receiver_1 == null)
          null;
        else {
          var tmp_2;
          if (out_0 == null) {
            tmp_2 = null;
          } else {
            tmp_2 = joinToString(out_0, VOID, VOID, VOID, VOID, VOID, BatchAndQueue$invoke$slambda$lambda_0);
          }
          tmp0_safe_receiver_1.hcv(['Failed to send request.  Sending ', e, ' to ' + tmp_2]);
        }
        if (out_0 == null)
          null;
        else {
          // Inline function 'kotlin.collections.forEach' call
          var _iterator__ex2g4s_2 = out_0.m1();
          while (_iterator__ex2g4s_2.n1()) {
            var element_2 = _iterator__ex2g4s_2.o1();
            element_2.qa8(e);
          }
        }
      }
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function BatchAndQueue$invoke$slambda$lambda(it) {
  return identityHashCode(it).toString();
}
function BatchAndQueue$invoke$slambda$lambda_0(it) {
  return identityHashCode(it).toString();
}
function *_generator_invoke__zhh2q8_0($this, input, $completion) {
  var deferred = CompletableDeferred();
  var tmp0_safe_receiver = $this.kej_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.hcv([toString(input) + ' starting with deferred ' + identityHashCode(deferred)]);
  }
  var tmp1_safe_receiver = $this.mej_1.p3(input);
  var tmp;
  if (tmp1_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    var tmp0_safe_receiver_0 = $this.kej_1;
    if (tmp0_safe_receiver_0 == null)
      null;
    else {
      tmp0_safe_receiver_0.hcv([toString(input) + ' already in progress']);
    }
    tmp1_safe_receiver.v(deferred);
    var tmp_0 = deferred.ga4($completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    return tmp_0;
  }
  if (tmp == null) {
    // Inline function 'kotlin.run' call
    var tmp0 = $this.mej_1;
    // Inline function 'kotlin.collections.set' call
    var value = arrayListOf([deferred]);
    tmp0.s3(input, value);
  }
  var tmp3_safe_receiver = $this.nej_1;
  var tmp_1;
  if (tmp3_safe_receiver == null) {
    tmp_1 = null;
  } else {
    // Inline function 'kotlin.takeUnless' call
    var tmp_2;
    if (!(tmp3_safe_receiver.p1() > 500)) {
      tmp_2 = tmp3_safe_receiver;
    } else {
      tmp_2 = null;
    }
    tmp_1 = tmp_2;
  }
  var tmp4_safe_receiver = tmp_1;
  var tmp_3;
  if (tmp4_safe_receiver == null) {
    tmp_3 = null;
  } else {
    // Inline function 'kotlin.let' call
    var tmp0_safe_receiver_1 = $this.kej_1;
    if (tmp0_safe_receiver_1 == null)
      null;
    else {
      tmp0_safe_receiver_1.hcv(['Adding ' + toString(input) + ' to existing queue']);
    }
    tmp_3 = tmp4_safe_receiver.v(input);
  }
  if (tmp_3 == null) {
    // Inline function 'kotlin.run' call
    var tmp0_safe_receiver_2 = $this.kej_1;
    if (tmp0_safe_receiver_2 == null)
      null;
    else {
      tmp0_safe_receiver_2.hcv(['Starting new queue for ' + toString(input)]);
    }
    var queue = HashSet().ha();
    queue.v(input);
    $this.nej_1 = queue;
    launch($this.iej_1, VOID, VOID, BatchAndQueue$invoke$slambda_0($this, queue));
  }
  try {
    var tmp_4 = deferred.ga4($completion);
    if (tmp_4 === get_COROUTINE_SUSPENDED())
      tmp_4 = yield tmp_4;
    return tmp_4;
  } catch ($p) {
    if ($p instanceof CancellationException()) {
      var e = $p;
      throw e;
    } else {
      if ($p instanceof Error) {
        var t = $p;
        var tmp6_safe_receiver = $this.kej_1;
        if (tmp6_safe_receiver == null)
          null;
        else {
          tmp6_safe_receiver.hcv(['Failed to report.  Error: ' + t.message]);
        }
        throw t;
      } else {
        throw $p;
      }
    }
  }
}
var BatchAndQueue$invoke$slambdaClass;
function BatchAndQueue$invoke$slambda() {
  if (BatchAndQueue$invoke$slambdaClass === VOID) {
    class $ {
      constructor($$this$run, $queue) {
        this.oej_1 = $$this$run;
        this.pej_1 = $queue;
      }
      yah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    BatchAndQueue$invoke$slambdaClass = $;
  }
  return BatchAndQueue$invoke$slambdaClass;
}
function BatchAndQueue$invoke$slambda_0($$this$run, $queue) {
  var i = new (BatchAndQueue$invoke$slambda())($$this$run, $queue);
  var l = ($this$launch, $completion) => i.yah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var BatchAndQueueClass;
function BatchAndQueue() {
  if (BatchAndQueueClass === VOID) {
    class $ {
      constructor(scope, batchWait, log, fulfill) {
        var tmp;
        if (batchWait === VOID) {
          // Inline function 'kotlin.time.Companion.seconds' call
          Companion_getInstance();
          tmp = toDuration(0.1, DurationUnit_SECONDS_getInstance());
        } else {
          tmp = batchWait;
        }
        batchWait = tmp;
        log = log === VOID ? null : log;
        this.iej_1 = scope;
        this.jej_1 = batchWait;
        this.kej_1 = log;
        this.lej_1 = fulfill;
        this.mej_1 = HashMap().n8();
        this.nej_1 = null;
      }
      xah(input, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, input), $completion);
      }
    }
    initMetadataForClass($, 'BatchAndQueue', VOID, VOID, VOID, [1]);
    BatchAndQueueClass = $;
  }
  return BatchAndQueueClass;
}
//region block: exports
export {
  BatchAndQueue as BatchAndQueue1zjqkogt1zg44,
};
//endregion

//# sourceMappingURL=BatchAndQueue.mjs.map
